import type { Reducer } from "@reduxjs/toolkit";
import { SET_BREADCRUMB_STACK, SET_MENU_IS_EXPANDED, TOGGLE_MENU } from "../../src/store/app/types";

export type MockAppState = {
    activeBranch: string;
    banner: { content: string } | null;
    loading: boolean;
    menuIsExpanded: boolean;
    menuItems: any[];
    breadcrumbStack: any[];
    errors: Record<string, any>;
    user: Record<string, any>;
    settings: Record<string, any>;
};

// A recognizable branch value lets tests assert that store-derived bindings actually flow from the store...
export const stubAppInitialState: MockAppState = {
    activeBranch: "stub-branch",
    banner: null,
    loading: false,
    menuIsExpanded: true,
    menuItems: [],
    breadcrumbStack: [],
    errors: {},
    user: {},
    settings: {},
};

// Handles just enough navigation actions for an interactive app shell (Sidenav/NavBar) in
// stub-hosted environments such as plugin sandboxes; everything else is intentionally inert...
export const appReducer: Reducer<MockAppState, any, MockAppState> = (state = stubAppInitialState, action) => {
    switch (action?.type) {
        case TOGGLE_MENU:
            return { ...state, menuIsExpanded: !state.menuIsExpanded };
        case SET_MENU_IS_EXPANDED:
            return { ...state, menuIsExpanded: action.value };
        case SET_BREADCRUMB_STACK:
            return { ...state, breadcrumbStack: action.breadcrumbStack };
        default:
            return state;
    }
};
